import { translate } from "./catalog.ts";
import type { Catalog, Catalogs, PlainKey } from "./catalog.ts";
import type { Language } from "./language-preference.ts";

// Words declared before any screen renders: a screen's document title, a
// navigation entry's label, an error code's copy. They are written once, at
// module load, so they cannot be read in a language yet; a phrase names the
// catalogue key and is read in the active language wherever it is shown.

export type Phrase = { readonly kind: "phrase"; readonly read: (language: Language) => string };

/** Text a declaration carries: a phrase, or a string already in the reader's language (a name, a count). */
export type Words = string | Phrase;

/** A catalogue key read later, in whatever language is active when it is shown. */
export function phrase<TSource extends Catalog>(catalogs: Catalogs<TSource>, key: PlainKey<TSource>): Phrase {
  return { kind: "phrase", read: (language) => translate(catalogs, language, { key }) };
}

export function readWords(words: Words, language: Language): string {
  return typeof words === "string" ? words : words.read(language);
}
